import { ld } from "@/lib/theme/light-dark";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import { H } from "../hero-tokens";

/** Footer link groups: every comparison and integration page, linked from each website page. */

// i18n-exempt: brand names of other vendors, never translated
const COMPARE = [
  ["casavi", "/compare/casavi"],
  ["Impower", "/compare/impower"],
  ["facilioo", "/compare/facilioo"],
  ["iDWELL", "/compare/idwell"],
  ["DOMUS", "/compare/domus"],
  ["Immoware24", "/compare/immoware24"],
  ["PowerHaus", "/compare/powerhaus"],
  ["easimo", "/compare/easimo"],
] as const;

// i18n-exempt: brand names of other vendors, never translated
const INTEGRATIONS = [
  ["Impower", "/integrations/impower"],
  ["DOMUS", "/integrations/domus"],
  ["Immoware24", "/integrations/immoware24"],
  ["PowerHaus", "/integrations/powerhaus"],
] as const;

const linkStyle = {
  fontSize: 13,
  color: ld("rgba(11,15,25,0.55)", "rgba(250,250,250,0.55)"),
  textDecoration: "none",
} as const;

function Group(props: {
  readonly title: string;
  readonly links: readonly { readonly label: string; readonly href: string }[];
}): ReactNode {
  return (
    <nav aria-label={props.title} style={{ minWidth: 0 }}>
      <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: H.ink }}>{props.title}</p>
      <ul
        style={{
          listStyle: "none",
          margin: "10px 0 0",
          padding: 0,
          display: "flex",
          flexWrap: "wrap",
          gap: "8px 18px",
        }}
      >
        {props.links.map((link) => (
          <li key={link.href}>
            <a className="mkhero-footlink" href={link.href} style={linkStyle}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export function HeroFooterLinks(): ReactNode {
  const t = useTranslations("marketing.heroSocialFooter");
  return (
    <div
      style={{
        marginTop: 46,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: 28,
      }}
    >
      <Group
        title={t("vergleiche")}
        links={[
          { label: t("alleImVergleich"), href: "/compare" },
          ...COMPARE.map(([name, href]) => ({ label: t("alternative", { name }), href })),
        ]}
      />
      <Group
        title={t("integrationen")}
        links={INTEGRATIONS.map(([name, href]) => ({ label: t("integration", { name }), href }))}
      />
    </div>
  );
}
